<template>
  <vs-select v-model="selectedDimension" :label="label" style="width:100%">
      <div :key="index" v-for="(item,index) in options">
          <vs-select-group :title="item.title" v-if="item.group">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in item.group" />
          </vs-select-group>
      </div>
  </vs-select>
</template>

<script>
export default {
  props: {
    value: String,
    label: String 
  },
  watch: {
    selectedDimension: function(newValue) {
        this.$emit("input", newValue)
    }
  },
  data () {
    return {
      selectedDimension: this.value,
    }
  },
  computed: {
    options: function() {
      return this.$store.state.statistics.dimensions 
    }
  }
}
</script>
